import { useT } from "../i18n/LanguageContext";
import { LANGS } from "../i18n/translations";

export default function LanguageSwitcher({ variant = "desktop" }) {
  const { lang, setLang, t } = useT();

  return (
    <div
      className={`inline-flex items-center gap-1 border border-white/15 rounded-full p-1 ${variant === "mobile" ? "text-sm" : "text-[10px]"}`}
      role="group"
      aria-label={t("lang.switcher_label")}
      data-testid={`lang-switcher-${variant}`}
    >
      {LANGS.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            onClick={() => setLang(l.code)}
            aria-label={l.full}
            aria-pressed={active}
            data-testid={`lang-btn-${l.code}`}
            className={`px-2.5 py-1 rounded-full tracking-[0.2em] uppercase transition-all duration-300 ${
              active
                ? "bg-[#D4AF37] text-black font-medium"
                : "text-white/60 hover:text-[#D4AF37]"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
